import { getMapViewBounds } from '../helpers/googleMap/getMapViewBounds';
import { collectMapViewBounds } from '../helpers/googleMap/collectMapViewBounds';
import { useState } from 'react';
import { transformMultiPolygon } from '../helpers/googleMap/transformPolygons';

export default function MapViewPolygonsController(initialZoom) {
  const [lastCoordinates, setCoordinates] = useState('');
  const [zoom, setZoom] = useState(initialZoom);
  const [polygons, setPolygons] = useState([]);
  const [outsideError, setOutsideError] = useState(false);

  async function fetchMapViewPolygons(map, force) {
    
    const newCoordinates = `${map.center.lat()}${map.center.lng()}`;
    const isBigZoom = map.zoom < 10;
    
    if (
      ((newCoordinates === lastCoordinates && zoom <= map.getZoom()) 
      || isBigZoom) && !force
      ) 
      return;
      
    if(force)
      await (() => new Promise((resolve, reject) => setTimeout(resolve, 500)))()

    const bounds = getMapViewBounds(map);
    const collectedBounds = collectMapViewBounds(bounds);
    const searchParams = new URLSearchParams({ bounds: JSON.stringify(collectedBounds) })
    
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/census/mapview/polygons?${searchParams}`, 
      {load: false}
    );

    if (!response || response.status !== 200 || response.status === 404) {
      setOutsideError(true);
      return;
    };

    setOutsideError(false);

    const newPolygons = await response.json();

    // performing transformation
    const transformedPolygons = transformMultiPolygon(newPolygons);

    setCoordinates(newCoordinates);
    setZoom(map.getZoom());
    setPolygons(transformedPolygons);
  }

  return { mapViewPolygons: polygons, fetchMapViewPolygons, outsideError };
}
